export default __webpack_public_path__ + "img/stop-video.350ea224.svg";